// src/pages/contact/ContactUs.js
import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const ContactUs = () => {
  return (
    <PolicyPage 
      title="Contact Us" 
      lastUpdated={new Date().toLocaleDateString()}
    >
      <div className="contact-content">
        <p>Need assistance? Reach out through these channels:</p>

        <h2>Email</h2>
        <p>
          <strong>General Support:</strong> helpdesksupport@yps.com.my<br />
          <strong>Urgent Issues:</strong> keith@yps.com.my (response within 1 hour)
        </p>

        <h2>Phone</h2>
        <p>+603-7733 8066 (Mon-Fri, 9 AM - 5 PM GMT+8)</p>

        <h2>Office Address</h2>
        <p>
          YONGPENG SOLUTIONS SDN BHD<br />
          B-07-01, ATRIA SOFO SUITES,<br />
          JALAN SS 22/23, DAMANSARA JAYA,<br />
          47400 PETALING JAYA, SELANGOR.
        </p>

        <h2>Operating Hours</h2>
        <p>Monday to Friday, 9:00 AM - 5:00 PM (GMT+8)</p>
      </div>
    </PolicyPage>
  );
};

export default ContactUs;